import { useEffect, useState } from "react";
import {
  ArrayInput,
  email,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useDataProvider,
} from "react-admin";
import { useForm } from "react-final-form";
import resourceNames from "../../../common/data/resourceNames";

interface Props {}

interface IChoice {
  id: string;
  name: string;
}

export const UsersSelectionForm = (props: Props) => {
  const [tenantRoles, setTenantRoles] = useState<IChoice[]>();
  const dataProvider = useDataProvider();
  const form = useForm();
  const tenantIdState = form.getFieldState("tenantId");

  useEffect(() => {
    if (!dataProvider) {
      return;
    }

    if (!tenantIdState?.value) {
      return;
    }

    dataProvider
      .getList(resourceNames.ADMIN_ROLES, {
        filter: { tenantId: tenantIdState.value },
        sort: { field: "name", order: "desc" },
        pagination: { page: 1, perPage: 1000 },
      })
      .then((value) =>
        setTenantRoles(value.data.map((x) => ({ id: x.name, name: x.name })))
      );
  }, [dataProvider, tenantIdState]);

  //  This is the server-side validation for user email address. Commented because react-final-form calls it million times when mounting the form.
  //   const unused = useCallback(
  //     (value: any, values: any, props: any) => {
  //       if (!axiosInstance) {
  //         return undefined;
  //       }

  //       return VirtualTenantApiFactory(
  //         undefined,
  //         axiosInstance.defaults.baseURL,
  //         axiosInstance
  //       )
  //         .apiAppVirtualtenantValidateEmailPost(value, values)
  //         .then((x) => {
  //           return x.data;
  //         });
  //     },
  //     [axiosInstance]
  //   );

  return (
    <ArrayInput source="users" validate={[required()]} {...props}>
      <SimpleFormIterator disableReordering>
        <TextInput source="email" validate={[required(), email()]} />
        <TextInput source="password" validate={[required()]} />
        <TextInput source="firstName" validate={[required()]} />
        <TextInput source="lastName" validate={[required()]} />
        {tenantRoles ? (
          <SelectInput choices={tenantRoles} translate="no" source="role" />
        ) : (
          <TextInput disabled source="role" />
        )}
      </SimpleFormIterator>
    </ArrayInput>
  );
};
